export const sizeExtractionRegex = /\d+(,\d+)*/;

export const extractSize = (size?: string) => {
	if (typeof size !== 'string') {
		return 0;
	}

	const match = size.match(sizeExtractionRegex);

	if (!match) {
		return 0;
	}

	return parseFloat(match[0].replace(',', '.'));
};
